import firebaseApp from "./firebaseApp";
import "firebase/analytics"

function analytics() {
    return firebaseApp().analytics();
}

export default analytics;
